import { createApp } from '@backstage/frontend-defaults';
import authPlugin from '@backstage/plugin-auth';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import {
  googleAuthApiRef,
  type ApiRef,
  type ProfileInfoApi,
  type BackstageIdentityApi,
  type SessionApi,
} from '@backstage/core-plugin-api';
import entregaPlugin from '@internal/plugin-entrega';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';

const googleProvider = {
  id: 'google',
  title: 'Google',
  message: 'Sign in with your Google account',
  apiRef: googleAuthApiRef as ApiRef<
    ProfileInfoApi & BackstageIdentityApi & SessionApi
  >,
};

const signInPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => props =>
          <SignInPage {...props} providers={[googleProvider]} />,
      },
    }),
  ],
});

export default createApp({
  features: [authPlugin, signInPageModule, catalogPlugin, entregaPlugin, navModule, homeModule],
});
